import { AccessLevel} from "./AccessLevel";

export default AccessLevel;
